exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#swiper__media-calls{transition:opacity 1s;opacity:1}", ""]);

// exports
